<template>
    <AppButton
        element="button"
        type="button"
        @click="openModal()"
        :disabled="disabled"
        :title="confirmText"
        :desired-action="desiredAction"
    >
        {{ buttonText }}
    </AppButton>
    <Modal :show="showModal" @close="showModal = false" :title="title">
        <slot></slot>
        <div class="mt-5 sm:mt-4">
            <form @submit.prevent="submit()" class="sm:flex sm:flex-row-reverse gap-2">
                <SubmitFormButton
                    :button-text="confirmMessage"
                    :processing="form.processing"
                    :desired-action="confirmButtonType"
                />
                <AppButton element="button" type="button" @click="dismiss()">
                    {{ $t('messages.cancel') }}
                </AppButton>
            </form>
        </div>
    </Modal>
</template>
<script>
import Modal from '@/components/Modal.vue';
import AppButton from '@/components/AppButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'ConfirmActionButton',
    emits: ['finished'],
    components: {
        SubmitFormButton,
        Modal,
        AppButton,
    },
    props: {
        href: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        danger: {
            type: Boolean,
            required: false,
            default: false,
        },
        method: {
            type: String,
            required: false,
            default: 'post',
        },
        params: {
            type: Object,
            required: false,
            default: () => {},
        },
        confirm: {
            type: Boolean,
            default: true,
        },
        confirmText: {
            type: String,
        },
        desiredAction: {
            type: Boolean,
            default: false,
            required: false,
        },
        buttonText: {
            type: String,
            default: null,
            required: true,
        },
    },
    methods: {
        submit() {
            this.form
                .transform((data) => {
                    data.params = this.params;
                    return data;
                })
                .post(this.href, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.dismiss();
                    },
                });
        },
        openModal() {
            if (!this.disabled) {
                this.showModal = true;
            }
        },
        dismiss() {
            this.showModal = false;
            this.$emit('finished');
        },
    },
    data() {
        return {
            showModal: false,
            confirmMessage: this.confirmText ? this.confirmText : this.$t('messages.confirm'),
            form: this.$inertia.form({
                _method: this.method,
                params: this.params,
            }),
        };
    },
    computed: {
        confirmButtonType() {
            if (this.danger) {
                return 'danger';
            }

            return true;
        },
    },
};
</script>
